import DashboardView from 'dashboard/DashboardView.react';
import Field from 'components/Field/Field.react';
import BoxFieldset from 'components/BoxFieldset/BoxFieldset.react';
import FlowView from 'components/FlowView/FlowView.react';
import renderFlowFooterChanges from 'lib/renderFlowFooterChanges';
import Label from 'components/Label/Label.react';
import React, { Fragment } from 'react';
import styles from 'dashboard/Settings/Settings.scss';
import Toggle from 'components/Toggle/Toggle.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import unique from 'lib/unique';
import { Promise } from 'parse';
import subscribeTo from 'lib/subscribeTo';
import * as SchemaStore from 'lib/stores/SchemaStore';


const userFieldOptions = {
  liveQueriesClasses: {
    friendlyName: 'live queries',
    type: 'boolean',
  },
};

@subscribeTo('Schema', 'schema')  // eslint-disable-line
export default class LiveQueriesSettings extends DashboardView { // eslint-disable-line
  constructor() {
    super();
    this.section = 'App Settings';
    this.subsection = 'Live Queries';
  }

  componentDidMount() {
    this.props.schema.dispatch(SchemaStore.ActionTypes.FETCH);
  }

  renderForm({
    fields, setField, resetFields,
  }) {
    let classOptions = [];
    const classList = this.props.schema.data.get('classes');

    if (classList && !classList.isEmpty()) {
      classOptions = Object.keys(classList.toObject()).filter(cls => cls !== '_Session');
    }

    fields.liveQueriesClasses = fields.liveQueriesClasses || [];
    const defClasses = this.initialFields.liveQueriesClasses || [];

    const rowLen = classOptions.length;

    const SettingsFieldsLiveQueries = (
      <BoxFieldset el="settings__live_queries_live_queries_classes">
        <div className={styles.settingsBox}>
          {
            classOptions.map((cls, i) => {
              return (
                <Fragment key={i}>
                  <Field
                    className="oneliner"
                    label={<Label
                      className="oneliner"
                      text={cls}
                      description="" />
                    }
                    input={<Toggle
                      key={`t-${i}`}
                      value={fields.liveQueriesClasses.includes(cls)}
                      type={Toggle.Types.YES_NO}
                      onChange={(value) => {
                        const classes = [].concat(fields.liveQueriesClasses);

                        if (value === true) {
                          classes.push(cls);
                        } else {
                          classes.splice(classes.indexOf(cls), 1);
                        }

                        if (defClasses.sort().join('') === classes.sort().join('')) {
                          return resetFields();
                        }

                        setField('liveQueriesClasses', classes.sort());

                        return null;
                      }} />
                    } />
                  {
                    rowLen !== i + 1
                      ? <div key={`hr-${i}`} className={styles.hr} />
                      : null
                  }
                </Fragment>
              );
            })}
        </div>
      </BoxFieldset>
    );

    const __onClick = (e) => {
      e.preventDefault();
      this.props.router.push({
        pathname: this.props.location.pathname,
        state: {
          isTeamDeskOpen: true,
          serviceName: this.context.currentApp.serviceName,
          ticketType: "other",
          subject: "I need more info about Live Queriees with Redis."
        },
      });
    }

    return (
      <div className={[styles.settings_page, 'ShowFooter'].join(' ')}>
        <Toolbar section={this.section} subsection={this.subsection} />
        <div className={styles.holder}>

          <p className={styles.limitedAccess}>
            Distributing Live Queries between multiple engines requires a message broker.<br />
            For optimal performance <a href="/tickets/new" onClick={__onClick}>contact us</a> to add a <a href="https://blog.sashido.io/sashidos-getting-started-guide-part-2/#realtimecommunication" target="_blank" rel="noreferrer noopener">Redis feature</a> or use a single engine to power your app with disabled auto-scaling mode.
          </p>

          {SettingsFieldsLiveQueries}
        </div>
      </div>
    );
  }

  renderContent() {
    if (!this.props.initialFields) {
      return <Toolbar section={this.section} subsection={this.subsection} />;
    }

    this.initialFields = this.props.initialFields;

    return (
      <FlowView
        initialFields={this.initialFields}
        footerContents={({ changes }) => renderFlowFooterChanges(changes, this.initialFields, generalFieldsOptions)}
        onSubmit={({ changes, setField }) => {
          return this.props.saveChanges(changes).then(({ successes, failures }) => {
            for (const k in successes) {
              setField(k, successes[k]);
            }

            if (Object.keys(failures).length > 0) {
              return { error: Object.values(failures).join(' ') };
            }
          })
            .catch(({ error, failures = {} }) => {
              return { error: unique(Object.values(failures).concat(error)).join(' ') };
            });
        }}
        validate={() => ''}
        renderForm={this.renderForm.bind(this)} />
    );
  }
}


let generalFieldsOptions = {
  liveQueriesClasses: {
    friendlyName: 'live queries settings',
  },
};
